import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
});

// Request interceptor to attach auth token
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('poshe_token') || sessionStorage.getItem('poshe_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('poshe_token');
      localStorage.removeItem('poshe_user');
      sessionStorage.removeItem('poshe_token');
      sessionStorage.removeItem('poshe_user');
      if (window.location.pathname !== '/login' && window.location.pathname !== '/checkout') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default API;
